import { compose, values } from 'ramda';
import { createSelector } from 'reselect';

import { NAME, SEARCH_TYPE } from './constants';
import { filterByEmptyColumns, groupByUsername, mapEmptyValues, removeUnnecessaryValues } from './utils';

export const getType = (state) => state[NAME].type;

export const getTasks = (state) => state[NAME].data;

export const getDialogErrors = (state) => state[NAME].errorDialogMsg;

const statusTypeColumnNames = ['taskCountBeforeDeadline', 'taskCountAfterNotification', 'taskCountAfterDeadline'];

const otherTypeColumnNames = [
	'taskCountBeforeDeadline',
	'taskCountAfterNotification',
	'taskCountAfterDeadline',
	'taskCountNotDone',
	'taskCountDoneSuccess',
	'taskCountDoneNotSuccess',
];

export const getStatusTasks = createSelector(
	getTasks,
	compose(values, removeUnnecessaryValues, groupByUsername, mapEmptyValues(statusTypeColumnNames)),
);

export const getSuccessTasks = createSelector(
	getTasks,
	compose(values, groupByUsername, filterByEmptyColumns(otherTypeColumnNames)),
);

export const getTasksPerUser = createSelector(
	getType,
	getStatusTasks,
	getSuccessTasks,
	(statsType, statusTasks, successTasks) => (statsType === SEARCH_TYPE.status ? statusTasks : successTasks),
);
